import { supabase } from '../../lib/supabase'
import type { OvertimeRecord } from './overtimeFigures'

type EntryRow = {
  id: string
  employee_id: string
  team_id: string
  date: string
  shift_template_id: string | null
  assignment_id: string | null
  planned_overtime_hours: number | string
  overtime_reason: string | null
  employees: { display_name: string; employee_identifier: string } | null
  teams: { name: string } | null
  shift_templates: { name: string } | null
  assignments: { name: string } | null
  status_codes: { category: string } | null
}

/**
 * Every schedule entry with planned overtime in the range that the signed-in
 * account can read; row-level security limits a supervisor to their own teams.
 */
export async function getOvertimeRecords(from: string, to: string): Promise<OvertimeRecord[]> {
  const { data, error } = await supabase
    .from('schedule_entries')
    .select(
      'id, employee_id, team_id, date, shift_template_id, assignment_id, planned_overtime_hours, overtime_reason, employees(display_name, employee_identifier), teams(name), shift_templates(name), assignments(name), status_codes(category)',
    )
    .gt('planned_overtime_hours', 0)
    .gte('date', from)
    .lte('date', to)
    .order('date', { ascending: true })
  if (error) throw new Error('The overtime report could not be loaded.')
  return ((data ?? []) as unknown as EntryRow[]).flatMap((row) =>
    row.employees
      ? [
          {
            id: row.id,
            employeeId: row.employee_id,
            identifier: row.employees.employee_identifier,
            employee: row.employees.display_name,
            teamId: row.team_id,
            team: row.teams?.name ?? '',
            date: row.date,
            shiftId: row.shift_template_id,
            shift: row.shift_templates?.name ?? '',
            assignmentId: row.assignment_id,
            assignment: row.assignments?.name ?? 'Unassigned',
            hours: Number(row.planned_overtime_hours),
            reason: row.overtime_reason,
            statusCategory: row.status_codes?.category ?? '',
          },
        ]
      : [],
  )
}
